import { PricingPlans } from '@/components/pricing-plans/PricingPlans.jsx'
import { TypographyH3 } from '@/components/ui/typography.jsx'
import OurAmazingLogo from '@/assets/logos/spring.png'
import { useAuthContext } from '@/context-state/AuthContext.jsx'
import { Button } from '@/components/ui/button.jsx'
import { AnalyticsService } from '@/services/analytics.js'
import { Icon } from '@iconify/react'
import { motion } from "framer-motion";
// import { show as showIntercom } from '@intercom/messenger-js-sdk/index.js'
import { GradientTextWithBorder } from '@/components/gradient/index.jsx'

export const FreeTierOverlay = () => {

    const { logout, user } = useAuthContext()

    return (
        <div className="h-screen bg-bubble-surfaces bg-center bg-cover bg-no-repeat bg-screenshot">


            <div className="flex flex-col justify-center h-full w-full items-center backdrop-blur-lg bg-white/55">
                <Button
                    variant="ghost"
                    className="flex gap-2 absolute w-fit top-5 left-4 z-50"
                    onClick={() => {
                        AnalyticsService.track('user-logged-out-free-tier-layout', { userName: user.name, userId: user._id })
                        logout()
                    }}
                >
                    <Icon icon="solar:logout-2-broken" />
                    Logout
                </Button>
                <div className="overflow-scroll flex flex-col gap-4 py-8 w-full">
                    <div className="flex flex-col mb-4">
                        <motion.div
                            className="relative"
                            initial={{ opacity: 0, top: "-30px" }}
                            animate={{ opacity: 1, top: 0 }}
                            transition={{ duration: 0.4 }}
                        >
                            <img
                                src={OurAmazingLogo}
                                alt="spting-ai-logo"
                                className="w-24 m-auto"
                            />
                        </motion.div>

                        <motion.div
                            className="relative"
                            initial={{ opacity: 0, top: "-50px" }}
                            animate={{ opacity: 1, top: 0 }}
                            transition={{ duration: 0.4 }}
                        >
                            <TypographyH3 className="text-center my-4 font-light">
                                Power your teams with the world’s most advanced Creative Intelligence platform
                            </TypographyH3>
                        </motion.div>

                        <motion.div
                            className="relative"
                            initial={{ opacity: 0, top: "-60px" }}
                            animate={{ opacity: 1, top: 0 }}
                            transition={{ duration: 0.4 }}
                        >
                            <GradientTextWithBorder showBorder className="px-4 py-2">
                                Your data is waiting
                            </GradientTextWithBorder>
                        </motion.div>
                    </div>
                    <PricingPlans />
                    <a href="mailto:info@upspring.ai" className="m-auto">
                        <Button
                            className="w-fit"
                            variant="outline"
                            size="sm"
                        // onClick={showIntercom}
                        >
                            Talk to us
                        </Button>
                    </a>
                </div>
            </div>
        </div>
    )
}